import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const priceLevelGapTypeLazy: ColumnPropertyLazySelect =  {
  recourseName: 'PriceLevelGapType',
  providerType: 'DEFAULT'
}

export const articleTypeLazy: ColumnPropertyLazySelect =  {
  recourseName: "WildberriesNetProfitDto",
  providerType: "DEFAULT"
}
